module.exports = __webpack_public_path__ + "img/downloadXLS.89ecccec.svg";